import { getHtml } from "../apis/templateHtml";
import { getUserInformation } from "../modules/userManager/UserManager";
/**
 * 現在の日時を取得する関数
 * @returns 日時文字列（例：2025年5月27日(木) 16:15）
 */
function getCurrentDateTime() {
    let nowTime = new Date();
    let nowYear = twoDigit(nowTime.getFullYear());
    let nowMonth = twoDigit(nowTime.getMonth() + 1); // 月は0ベース補正
    let nowDay = twoDigit(nowTime.getDate());
    let nowHour = twoDigit(nowTime.getHours());
    let nowMin = twoDigit(nowTime.getMinutes());
    let nowSec = twoDigit(nowTime.getSeconds());
    const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
    return nowYear + "年" + nowMonth + "月" + nowDay + "日(" + dayOfWeek[nowTime.getDay()] + ") " + nowHour + ":" + nowMin + ":" + nowSec;
}
/**
 * 0埋め2桁処理
 * @param num
 * @returns
 */
function twoDigit(num) {
    let ret;
    if (num < 10)
        ret = "0" + num;
    else
        ret = num;
    return ret;
}
/**
 * 時計描画処理
 */
function showClock() {
    const realTime = document.getElementById("realtime");
    if (realTime) {
        realTime.innerHTML = getCurrentDateTime();
    }
}
export const initializeHeader = async () => {
    const contentsElement = document.getElementById('header');
    // header要素が存在しない場合はエラーログを出力して処理を中断
    if (!contentsElement) {
        console.error('Header element not found. DOM may not be ready yet.');
        return;
    }
    const contents = await getHtml("/parts/header.html");
    if (contents) {
        // 案件一覧画面のHTMLを生成
        contentsElement.innerHTML = contents;
    }
    // ユーザー情報を動的に取得
    try {
        const userInfo = await getUserInformation();
        const username = userInfo?.[0]?.employee_name || "ユーザー"; // dataListの最初の要素からemployee_nameを取得
        const usernameElement = document.getElementById('username');
        if (usernameElement) {
            usernameElement.innerHTML = username;
        }
    }
    catch (error) {
        console.error('ユーザー情報の取得に失敗しました:', error);
        // エラー時はデフォルト値を表示
        const usernameElement = document.getElementById('username');
        if (usernameElement) {
            usernameElement.innerHTML = "ユーザー";
        }
    }
    // 現在の日時を表示
    showClock();
    // 1秒毎に更新
    setInterval(() => {
        showClock();
    }, 1000);
};
/**
 * 既存のユーザー情報を使用してヘッダーを初期化する
 * @param userInfo ユーザー情報
 */
export const initializeHeaderWithUserInfo = async (userInfo) => {
    const contentsElement = document.getElementById('header');
    // header要素が存在しない場合はエラーログを出力して処理を中断
    if (!contentsElement) {
        console.error('Header element not found. DOM may not be ready yet.');
        return;
    }
    const contents = await getHtml("/parts/header.html");
    if (contents) {
        // 案件一覧画面のHTMLを生成
        contentsElement.innerHTML = contents;
    }
    // 既存のユーザー情報を使用
    try {
        const username = userInfo?.[0]?.employee_name || "ユーザー"; // dataListの最初の要素からemployee_nameを取得
        const usernameElement = document.getElementById('username');
        if (usernameElement) {
            usernameElement.innerHTML = username;
        }
    }
    catch (error) {
        console.error('ユーザー情報の設定に失敗しました:', error);
        // エラー時はデフォルト値を表示
        const usernameElement = document.getElementById('username');
        if (usernameElement) {
            usernameElement.innerHTML = "ユーザー";
        }
    }
    // 現在の日時を表示
    showClock();
    // 1秒毎に更新
    setInterval(() => {
        showClock();
    }, 1000);
};
